import * as React from 'react';
import styles from './styles.module.styl';
export var Entry = function (_a) {
    var title = _a.title, url = _a.url, logo = _a.logo;
    return (React.createElement("a", { href: url, className: styles.link },
        React.createElement("div", { className: styles.entry },
            React.createElement("div", { className: styles.logo },
                React.createElement("img", { src: logo, alt: "Quickstart logo" })),
            React.createElement("div", { className: styles.title }, title))));
};
